
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { CurrencyInputPipe } from '@hub/pipes/CurrencyInput.pipe';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';
import { Constants } from '@hub/common/Constants';


const noop = () => { };

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputV2Component),
  multi: true
};

@Component({
  selector: 'fm-input-v2',
  templateUrl: 'form-input.component.html',
  styleUrls: ['form-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    // {provide: BaseErrorForm, useExisting: forwardRef(() => FormInputComponent)}],
})
export class FormInputV2Component extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { super(); }

  @Input() public useCurrencyPipe: boolean = false;
  @Input() public isWholeNumber: boolean = false;
  @Input() public isWholeNumberWithNegative: boolean = false;
  @Input() public type: string;
  @Input() public disabled: boolean = false;
  @Input() public placeholder: string;
  @Output() onChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('in') public input: ElementRef;

  public tabindex: string;
  @Input('tabindex')
  public set tabind(val: string) {
    this.tabindex = String(val);
  }

  keyFilter: any;
  public isFocused: boolean = false;
  public inputType: string;
  private numOfTabs: number = 0;
  private innerValue: any = '';
  private blockSpecial = /^[^]+$/;
  private currencyPipe: CurrencyInputPipe = new CurrencyInputPipe();
  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    // if (this.type) {
    if(this.type == "number") {
      if(!this.placeholder) {
        this.placeholder = 'Enter Number';
      }
      if(!this.isWholeNumber) {
        this.keyFilter = "int";
      } else {
        this.keyFilter = "pint";
      }
    } else {
      this.inputType = 'text';
      this.keyFilter = this.blockSpecial;
      this.placeholder = 'Enter Text Here';
    }
    this.formEventService.setIndex(parseInt(this.tabindex));

    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  public ngOnDestroy(): void {
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.value) {
      this.writeValue(v.trim());
      this.onChangeCallback(v.trim());
    }
  }

  //From ControlValueAccessor interface
  public writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
    if (this.useCurrencyPipe) {
      this.innerValue = this.currencyPipe.transformNoSuffix(value);
    }
  }

  //From ControlValueAccessor interface
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onFocus(value) {
    if(this.useCurrencyPipe) {
      this.isFocused = true;
      this.value = this.currencyPipe.parse(value);
    }
  } 

  onBlur(value) {
    if (this.useCurrencyPipe) {
      this.isFocused = true;
      this.innerValue = this.currencyPipe.transform(value, 0);
    }
    this.onTouchedCallback();
  }

  onChange(newValue: string) {
    if (newValue !== this.innerValue) {
      this.writeValue(newValue.trim());
    }
    this.onChanged.emit(newValue.trim());
  }
}
